import { functionLinks } from "../data/navLinks";

const ENTITY_FALLBACKS = {
  order: "/account/order",
  debitNote: "/m/gi/debitNote",
  renewal: "/gi/renewal",
  client: "/account/client",
  commissionStatement: "/account/commissionStatement",
  bankTransaction: "/account/bankTransaction",
  user: "/operation/user",
  product: "/operation/product",
  provider: "/operation/provider",
  productType: "/operation/productType",
  quiz: "/operation/quiz",
};

const getScopePrefixes = (pathname = "") => {
  if (pathname.startsWith("/m/gi")) return ["/m/gi/"];
  if (pathname.startsWith("/management")) return ["/management/", "/m/"];
  if (pathname.startsWith("/account")) return ["/account/"];
  if (pathname.startsWith("/consultant")) return ["/consultant/"];
  if (pathname.startsWith("/operation")) return ["/operation/"];
  if (pathname.startsWith("/gi")) return ["/gi/"];
  return null;
};

const pickScopedPath = (candidates, scopePrefixes) => {
  if (!candidates.length) return undefined;
  if (candidates.length === 1) return candidates[0];
  if (!scopePrefixes?.length) return candidates[0];

  const scoped = candidates.find((path) =>
    scopePrefixes.some((prefix) => path.startsWith(prefix)),
  );
  return scoped ?? candidates[0];
};

/**
 * Resolve the list/detail route for an entity using the current user role.
 * Priority: entityLinks → granted page links (nav, scope-aware) → static fallback.
 */
export function resolveEntityPath(entity, userRole, currentPathname = "") {
  const fromEntityLinks = userRole?.entityLinks?.find(
    (entry) => entry.entity === entity,
  )?.link;
  if (fromEntityLinks) return fromEntityLinks;

  const grantedLinkIds = new Set(
    (userRole?.links ?? [])
      .filter((entry) => (entry.accessRight ?? 0) > 0)
      .map((entry) => entry.link),
  );

  const pathSuffix = `/${entity}`;
  const candidates = functionLinks
    .filter(
      (page) =>
        grantedLinkIds.has(page.linkId) && page.link?.endsWith(pathSuffix),
    )
    .map((page) => page.link);

  const pathname =
    currentPathname ||
    (typeof window !== "undefined" ? window.location.pathname : "");
  const scoped = pickScopedPath(candidates, getScopePrefixes(pathname));
  if (scoped) return scoped;

  return ENTITY_FALLBACKS[entity];
}
